import { SpatialProducerProfile, SpatialRegistrationEditor } from '../../../shared/models/be/spatial';

export function sameSpatialProfile(left: SpatialProducerProfile, right: SpatialProducerProfile | null): boolean {
  return !!right && left.calibration_set_id === right.calibration_set_id
    && left.coordinate_systems?.sensor_input === right.coordinate_systems?.sensor_input
    && left.coordinate_systems?.global_output === right.coordinate_systems?.global_output
    && left.coordinate_systems?.input_already_floor_levelled === right.coordinate_systems?.input_already_floor_levelled;
}

/** Proposes a match; only an explicit save writes a binding. */
export function suggestSpatialBindings(registration: SpatialRegistrationEditor): Record<string, string> {
  const selections: Record<string, string> = Object.create(null);
  const enabled = registration.sensors.filter(sensor => sensor.enabled);
  const reserved = new Set(enabled.filter(sensor => sensor.assignedUnitId === registration.unitId && sensor.deviceId).map(sensor => sensor.deviceId!));
  for (const sensor of enabled) {
    if (sensor.deviceId && sensor.assignedUnitId === registration.unitId) { selections[sensor.sensorId] = sensor.deviceId; continue; }
    selections[sensor.sensorId] = '';
    if (sensor.assignedUnitId && sensor.assignedUnitId !== registration.unitId) continue;
    if (!sensor.expectedDeviceLabel || enabled.filter(other => other.expectedDeviceLabel === sensor.expectedDeviceLabel).length !== 1) continue;
    const matches = registration.devices.filter(device => device.available && !reserved.has(device.deviceId) && device.deviceLabel === sensor.expectedDeviceLabel);
    if (matches.length === 1) { selections[sensor.sensorId] = matches[0].deviceId; reserved.add(matches[0].deviceId); }
  }
  return selections;
}
